import { Component } from 'react'
import * as styles from 'components/features/socialFeed/SocialProfilePopup/SocialProfilePopup.styl'
import { SocialProfileState, ComposeId } from 'interfaces/feed'
import { isMobileViewport } from 'helpers/viewportHelpers'
import Popup from 'components/features/pfm/Popup/Popup'
import SocialProfileHeader from 'components/features/socialFeed/SocialProfileHeader/SocialProfileHeader'
import SocialProfileFormContainer from 'components/features/socialFeed/SocialProfileForm/SocialProfileFormContainer'
import SocialProfileConfirmationContainer from 'components/features/socialFeed/SocialProfileConfirmation/SocialProfileConfirmationContainer'
import Scrollable from 'components/atoms/Scrollable'
import Button from 'components/features/pfm/Button/Button'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import { AnalyticsClick } from 'components/features/pfm/AnalyticsClick/AnalyticsClick'
import { Cropper } from 'components/features/pfm/Cropper/Cropper'

export type SocialProfilePopupStateProps = {
  step: SocialProfileState['step']
  focusComposeId?: ComposeId
}

export type SocialProfilePopupDispatchProps = {
  onComplete: (focusComposeId?: ComposeId) => void
  onClose: () => void
}

type SocialProfilePopupProps =
  & SocialProfilePopupStateProps
  & SocialProfilePopupDispatchProps

class SocialProfilePopup extends Component<SocialProfilePopupProps> {
  render () {
    const { step, onClose } = this.props

    if (!step) {
      return null
    }

    const popupContent = (
      <>
        <SocialProfileHeader step={ step } />
        <div className={ styles.contentWrapper }>
          { this.renderContent() }
        </div>
      </>
    )

    const isMobile = isMobileViewport()

    return (
      <Popup onCloseButtonClick={ onClose }>
        { isMobile && popupContent }
        { !isMobile && (
          <Scrollable heightRelativeToParent='100%' alwaysShowScrollbar>
            { popupContent }
          </Scrollable>
        )}
      </Popup>
    )
  }

  renderContent () {
    const { step, onClose } = this.props

    switch (step) {
      case 'form':
        return (
          <>
            <SocialProfileFormContainer />
            <div className={ styles.cancelLinkWrapper }>
              <a
                data-qa-marker='cancel-button'
                onClick={ onClose }
              >
                Cancel
              </a>
            </div>
          </>
        )

      case 'confirmation':
        return (
          <>
            <SocialProfileConfirmationContainer />
            <AnalyticsClick
              className={ styles.startPostingButtonWrapper }
              category='module-feed_profile'
              action='click-start_posting'
            >
              <Button
                fullWidth
                qaMarker='start-posting-button'
                onClick={ this.handleComplete }
              >
                Start Posting
              </Button>
            </AnalyticsClick>
            <div className={ styles.settingsNoteWrapper }>
              If anything seems incorrect you can edit your profile on your <NavigationLink qaMarker='settings-link' to='settings'>settings</NavigationLink> page.
            </div>
          </>
        )

      case 'cropper':
        return (
          <Cropper theme='popup' />
        )

      default:
        return null
    }
  }

  private handleComplete = () => {
    const { focusComposeId, onComplete } = this.props

    onComplete(focusComposeId)
  }
}

export default SocialProfilePopup
